import React from 'react';
import SubPage from '#/common/components/SubPage';
import AssetPlans from '../components/AssetPlans';

const AssetPlansPage: React.FC = () => {
  return (
    <SubPage title="Asset Plans" type="list" hideSelectToggle>
      <AssetPlans />
    </SubPage>
  );
};

export default React.memo(AssetPlansPage);
